import { render, staticRenderFns } from "./BaseTimeText.vue?vue&type=template&id=5b9fbd07&"
import script from "./BaseTimeText.vue?vue&type=script&lang=js&"
export * from "./BaseTimeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports